import ConfirmationDialog from './ConfirmationDialog.js';

/** Backwards-compatible Article adapter; the real application shares one dialog service. */
export default class ArticleDeleteConfirmation extends ConfirmationDialog {}
